// extracted by mini-css-extract-plugin
export default {"active":"color-section__active___WKGm1","wrapper":"color-section__wrapper___Yc6td","color":"color-section__color____gyCB"};